import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=613f0a51&scoped=true"
import script from "./UploadModal.vue?vue&type=script&lang=js"
export * from "./UploadModal.vue?vue&type=script&lang=js"
import style0 from "./UploadModal.vue?vue&type=style&index=0&id=613f0a51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613f0a51",
  null
  
)

export default component.exports